import { useGLTF, Text } from '@react-three/drei';
import gsap from 'gsap';
import React, { useEffect, useRef, useState } from 'react';
import { MyContext } from './MyContext';
import { useContext } from 'react';
import * as THREE from 'three';
import { useFrame } from '@react-three/fiber';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { alternatives } from 'joi';

export default function Model(props) {
  const {
    counter1visible,
    setcounter1visible,
    counter2visible,
    setcounter2visible,
    Lightmode,
    setLightmode,
    width,
    setwidth,
    length,
    setlength,
    height,
    setsetheight,
    numerofwalls,
    setnumerofwalls,
    numerofcabins,
    setnumerofcabins,
    numberofcounters,
    setnumberofcounters,
    splitwall,
    setsplitwall,
    bigcabin,
    setbigcabin,
    counterdata,
    setcounterdata,
    showWallsLabels,
    getUnit,
  } = useContext(MyContext);

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { nodes, materials } = useGLTF('/door.glb');

  const [ease, setease] = new useState('power1.inOut');
  const [duration, setduration] = new useState(1.2);

  materials['Material.002'].toneMapped = false;
  materials['Material.002'].map.anisotropy = 10;

  useEffect(() => {
    Lightmode
      ? (materials['Material.002'].emissiveIntensity = 2)
      : (materials['Material.002'].emissiveIntensity = 1);
  }, [Lightmode]);

  function Show(itemsshow, itemsnotshow) {
    if (numerofwalls > 1) {
      itemsshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: (width - 0.4) * 0.862,
          y: 0,
          z: i * 0.858 + 0.465,
          duration: duration,

          ease: ease,
        });
      });

      itemsnotshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: 24,
          y: 0,
          z: i * 0.858 + 0.47,
          duration: duration,

          ease: ease,
        });
      });
    } else {
      itemsshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: 24,
          y: 0,
          z: i * 0.858 + 0.47,
          duration: duration,

          ease: ease,
        });
      });

      itemsnotshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: 24,
          y: 0,
          z: i * 0.858 + 0.47,
          duration: duration,

          ease: ease,
        });
      });
    }
  }

  function SideWalls(itemsshow, itemsnotshow) {
    itemsshow.forEach((el, i) => {
      gsap.to(el.current.position, {
        x: i * 0.858,
        y: 0,
        z: 0,
        duration: duration,

        ease: ease,
      });
    });

    itemsnotshow.forEach((el, i) => {
      gsap.to(el.current.position, {
        x: 24,
        y: 0,
        z: 0,
        duration: duration,

        ease: ease,
      });
    });
  }

  function Rightsidewalls(itemsshow, itemsnotshow) {
    if (numerofwalls == 3) {
      itemsshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: i * 0.858 + 0.07,
          y: 0,
          z: 1.858 + 0.86 * (length - 2),
          duration: duration,

          ease: ease,
        });
      });

      itemsnotshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: 24,
          y: 0,
          z: 1.858 + 0.86 * (length - 2),
          duration: duration,

          ease: ease,
        });
      });
    } else {
      itemsshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: 24,
          y: 0,
          z: 1.858 + 0.86 * (length - 2),
          duration: duration,

          ease: ease,
        });
      });

      itemsnotshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: 24,
          y: 0,
          z: 1.858 + 0.86 * (length - 2),
          duration: duration,

          ease: ease,
        });
      });
    }
  }

  function BigLeftWalls(itemsshow, itemsnotshow) {
    itemsshow.forEach((el, i) => {
      gsap.to(el.current.position, {
        x: i * 1.71 + 0.453,
        y: 0,
        z: 0,
        duration: duration,

        ease: ease,
      });
    });

    itemsnotshow.forEach((el, i) => {
      gsap.to(el.current.position, {
        x: 24,
        y: 0,
        z: 0,
        duration: duration,

        ease: ease,
      });
    });
  }

  function BigRightWalls(itemsshow, itemsnotshow) {
    if (numerofwalls == 3) {
      itemsshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: i * 1.71 + 0.48,
          y: 0,
          z: 1.858 + 0.86 * (length - 2),
          duration: duration,

          ease: ease,
        });
      });

      itemsnotshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: 24,
          y: 0,
          z: 1.858 + 0.86 * (length - 2),
          duration: duration,

          ease: ease,
        });
      });
    } else {
      itemsshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: 24,
          y: 0,
          z: (length - 0.01) * 0.862,
          duration: duration,

          ease: ease,
        });
      });

      itemsnotshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: 24,
          y: 0,
          z: (length - 0.01) * 0.862,
          duration: duration,

          ease: ease,
        });
      });
    }
  }

  function BigFrontWalls(itemsshow, itemsnotshow) {
    if (numerofwalls > 1) {
      itemsshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: (width - 0.4) * 0.862,
          y: 0,
          z: i * 1.715 + 0.92,
          duration: duration,

          ease: ease,
        });
      });

      itemsnotshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: 24,
          y: 0,
          z: i * 0.858 + 0.9,
          duration: duration,

          ease: ease,
        });
      });
    } else {
      itemsshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: 24,
          y: 0,
          z: i * 0.858 + 0.47,
          duration: duration,

          ease: ease,
        });
      });

      itemsnotshow.forEach((el, i) => {
        gsap.to(el.current.position, {
          x: 24,
          y: 0,
          z: i * 0.858 + 0.47,
          duration: duration,

          ease: ease,
        });
      });
    }
  }

  function WallMove(el, pos) {
    gsap.to(el.current.position, {
      x: pos.x ? pos.x : el.current.position.x,

      z: pos.y,
      duration: duration,

      ease: ease,
    });
  }

  function WallMoveFront(el, pos) {
    gsap.to(el.current.position, {
      x: (width - 0.4) * 0.862,
      z: pos.z,

      duration: duration,

      ease: ease,
    });
  }

  function WallMoveRight(el, pos) {
    gsap.to(el.current.position, {
      x: pos.x,

      duration: duration,

      ease: ease,
    });
  }

  function Counter1(show, position, rotation) {
    if (width < 2 || length < 2 || numberofcounters < 1) {
      show = false;
    }

    if (width < 2 && numerofwalls == 1) {
      show = true;
    }

    if (length < 2) {
      show = false;
    }

    if (numerofwalls == 3 && length < 3) {
      show = false;
    }

    if (numerofwalls == 2) {
      if (numerofcabins == 1 && width == 2 && length == 2) {
        show = false;
      }
    }

    if (show) {
      setcounter1visible(true);

      gsap.to(counter1.current.position, {
        x: position.x,
        y: position.y,
        z: position.z,
        duration: duration,

        ease: ease,
      });

      gsap.to(counter1.current.rotation, {
        x: rotation.x,
        y: rotation.y,
        z: rotation.z,
        duration: duration,

        ease: ease,
      });
    } else {
      gsap.to(counter1.current.position, {
        x: -24,
        y: position.y,
        z: position.z,
        duration: duration,

        ease: ease,
      });

      gsap.to(counter1.current.rotation, {
        x: 0,
        y: 0,
        z: 0,
        duration: duration,

        ease: ease,
      });

      setcounter1visible(false);
      // setnumberofcounters(0);
    }
  }

  function Counter2(show, position, rotation) {
    if (width < 2 || length < 2 || numberofcounters < 2) {
      show = false;
    }

    if (width < 2 && numerofwalls < 2) {
      show = false;
    }

    if (length < 3 && numerofwalls == 3 && numerofcabins == 1) {
      show = false;
    }

    if (numerofwalls == 2) {
      if (numerofcabins == 1 && width < 2) {
        show = false;
      }

      // if (numerofcabins == 1 && length > 2 && length < 5) {
      //   show = false;
     
      // }

      if (numerofcabins == 1 && length == 2 && width < 4) {
        show = false;
        
      }

      if (numerofcabins == 1 && length < 2) {
        show = false;
        
      }
    }


    if (numerofwalls == 3 && length < 4 && numerofcabins == 0) {
      show = false;
    }

    // if (numerofwalls == 2 && width == 2 && length == 2) {
    //   show = false;
    // }

    if (numerofwalls == 3 && numerofcabins == 1 && length < 5 && width < 4) {
      show = false;
    }

   

    if (
      numerofwalls == 3 &&
      numerofcabins == 1 &&
      numberofcounters == 2 &&
      length == 4 &&
      width == 3
    ) {
      show = true;
    }

 
   
    if(numerofwalls == 2 && numerofcabins == 1 && numberofcounters == 2 && length == 4 && width == 4){
      show = true
    }

    if(numerofwalls == 2 && numerofcabins == 1 && width == 3 && length == 3){
      show = false
     }

     if(numerofwalls == 2 && numerofcabins == 1 && numberofcounters == 2 && width == 2 && length < 4){
      show = false
     }

   

    if (show) {
      gsap.to(counter2.current.position, {
        x: position.x,
        y: position.y,
        z: position.z,
        duration: duration,

        ease: ease,
      });

      gsap.to(counter2.current.rotation, {
        x: rotation.x,
        y: rotation.y,
        z: rotation.z,
        duration: duration,

        ease: ease,
      });

      //    setcounter2visible(true)
    } else {
      gsap.to(counter2.current.position, {
        x: -24,
        y: position.y,
        z: position.z,
        duration: duration,

        ease: ease,
      });

      gsap.to(counter2.current.rotation, {
        x: 0,
        y: 0,
        z: 0,
        duration: duration,

        ease: ease,
      });

      // setcounter2visible(false)
    }
  }

  const groundref = useRef();

  const ref = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();
  const ref5 = useRef();
  const ref6 = useRef();
  const ref7 = useRef();
  const ref8 = useRef();
  const ref9 = useRef();
  const ref10 = useRef();
  const ref11 = useRef();
  const ref12 = useRef();
  const ref13 = useRef();
  const ref14 = useRef();
  const ref15 = useRef();
  const ref16 = useRef();
  const ref17 = useRef();
  const ref18 = useRef();
  const ref19 = useRef();
  const bigwallleft1 = useRef();
  const bigwallleft2 = useRef();
  const bigwallleft3 = useRef();

  const bigwallfront1 = useRef();
  const bigwallfront2 = useRef();
  const bigwallfront3 = useRef();

  const bigwallright1 = useRef();
  const bigwallright2 = useRef();
  const bigwallright3 = useRef();

  const counter1 = useRef();
  const counter2 = useRef();
  const Cabin1 = useRef();
  const Cabin2 = useRef();
  const Cabinwall = useRef();
  const BigCabinwall = useRef();

  const textref1 = useRef();
  const textref2 = useRef();
  const textref3 = useRef();
  const textref4 = useRef();
  const textref5 = useRef();
  const textref6 = useRef();
  const textref7 = useRef();
  const textref8 = useRef();
  const textref9 = useRef();
  const textref10 = useRef();
  const textref11 = useRef();
  const textref12 = useRef();
  const textref13 = useRef();
  const textref14 = useRef();
  const textref15 = useRef();
  const textref16 = useRef();
  const textref17 = useRef();
  const textref18 = useRef();
  const textref19 = useRef();
  const textref20 = useRef();
  const textref21 = useRef();
  const textref22 = useRef();
  const textref23 = useRef();
  const textref24 = useRef();
  const textref25 = useRef();
  const textref26 = useRef();
  const textref27 = useRef();
  const textref28 = useRef();
  const textref29 = useRef();
  const textref30 = useRef();
  const textref31 = useRef();
  const textref32 = useRef();

  const groupref = useRef();

  const frontwalls = [ref7, ref8, ref9, ref10, ref11, ref12, ref13];
  const sidewalls = [ref, ref2, ref3, ref4, ref5, ref6];
  const rightsidewalls = [ref14, ref15, ref16, ref17, ref18, ref19];
  const cabinwalls = [Cabin1, Cabin2, Cabinwall];
  const bigwallsleft = [bigwallleft1, bigwallleft2, bigwallleft3];
  const bigwallsright = [bigwallright1, bigwallright2, bigwallright3];
  const bigwallsfront = [bigwallfront1, bigwallfront2, bigwallfront3];

  let orange = 85;
  let green = 100;
  let turquoise = 185;
  let red = 200;
  let unit = ' mm';

  useEffect(() => {
    setcounterdata(prevState => {
      if (prevState.length >= 3) {
        // Check if the array has at least 3 items
        return [
          counter1visible, // Update the first item
          counter2visible, // Update the second item
          prevState[2], // Keep the third item unchanged
        ];
      }
      return prevState; // Return the previous state unchanged if it doesn't have enough items
    });
  }, [length, width]);

  useEffect(() => {
    if (width == 1) {
      if (splitwall) {
        SideWalls([ref], [ref2, ref3, ref5, ref6, ref7]);
        Rightsidewalls([ref14], [ref15, ref16, ref17, ref18, ref19]);

        BigLeftWalls([], [bigwallleft1, bigwallleft2, bigwallleft3]);
        BigRightWalls([], [bigwallright1, bigwallright2, bigwallright3]);
      } else {
        BigLeftWalls([], [bigwallleft1, bigwallleft2, bigwallleft3]);

        SideWalls([ref], [ref2, ref3, ref5, ref6, ref7]);
        Rightsidewalls([ref14], [ref15, ref16, ref17, ref18, ref19]);
        BigRightWalls([], [bigwallright1, bigwallright2, bigwallright3]);
      }

      gsap.to(groundref.current.scale, {
        z: 0.432,
        x: 0.576,
        duration: duration,

        ease: ease,
      });
    }

    if (width == 2) {
      // Counter1(true,new THREE.Vector3(-0.19,0,0.5835), new THREE.Vector3(0,0,0))

      if (splitwall) {
        SideWalls([], [ref, ref2, ref3, ref5, ref6, ref7]);
        Rightsidewalls([], [ref14, ref15, ref16, ref17, ref18, ref19]);
        BigLeftWalls([bigwallleft1], [bigwallleft2]);
        BigRightWalls([bigwallright1], [bigwallright2, bigwallright3]);

        if (numerofwalls == 3) {
          WallMove(bigwallleft1, new THREE.Vector3(0.45, 0, 0));
        }

        if (numerofcabins == 1) {
          WallMove(bigwallleft1, new THREE.Vector3(27, 0, 0));
          WallMove(ref, new THREE.Vector3(0.004, 0, 0));
          WallMove(ref2, new THREE.Vector3(0.85, 0, 0));
          WallMoveRight(bigwallright1, new THREE.Vector3(27, 0, 0));

          if (numerofwalls == 3) {
            WallMoveRight(ref14, new THREE.Vector3(0.085, 0, 0));
            WallMoveRight(ref15, new THREE.Vector3(0.935, 0, 0));

            WallMoveRight(ref15, new THREE.Vector3(27, 0, 0));
            WallMoveRight(ref14, new THREE.Vector3(27, 0, 0));
            WallMoveRight(bigwallright1, new THREE.Vector3(0.477, 0, 0));
          }
        }
      } else {
        BigLeftWalls([], [bigwallleft1, bigwallleft2, bigwallleft3]);
        BigRightWalls([], [bigwallright1, bigwallright2, bigwallright3]);

        SideWalls([ref, ref2], [ref3, ref5, ref6, ref7]);
        Rightsidewalls([ref14, ref15], [ref16, ref17, ref18, ref19]);
        WallMove(bigwallleft1, new THREE.Vector3(27, 0, 0));
        WallMove(bigwallleft2, new THREE.Vector3(27, 0, 0));
      }

      gsap.to(groundref.current.scale, {
        z: 0.862,
        x: 0.576,
        duration: duration,

        ease: ease,
      });
    }

    if (width == 3) {
      if (splitwall) {
        SideWalls([], [ref, ref2, ref3, ref5, ref6, ref7]);
        Rightsidewalls(
          [ref14, ref15, ref16],
          [ref14, ref15, ref17, ref18, ref19]
        );
        BigLeftWalls([bigwallleft1], [bigwallleft2, bigwallleft3]);
        BigRightWalls([bigwallright1], [bigwallright2, bigwallright3]);

        if (numerofwalls == 2 && numerofcabins == 0) {
          WallMove(ref, new THREE.Vector3(1.71, 0, 0));
        }

        if (numerofwalls == 2 && numerofcabins == 1) {
          WallMove(bigwallleft1, new THREE.Vector3(1.305, 0, 0));
          WallMove(bigwallleft2, new THREE.Vector3(27, 0, 0));
          WallMove(ref, new THREE.Vector3(-0.01, 0, 0));
        }

        if (numerofwalls == 3) {
          WallMoveRight(bigwallright1, new THREE.Vector3(0.5, 0, 0));
          WallMoveRight(ref16, new THREE.Vector3(1.8, 0, 0));
          WallMove(bigwallleft1, new THREE.Vector3(0.45, 0, 0));
          WallMove(ref, new THREE.Vector3(1.71, 0, 0));

          if (numerofcabins == 1) {
            WallMoveRight(ref14, new THREE.Vector3(1.8, 0, 0));
            WallMoveRight(ref16, new THREE.Vector3(27, 0, 0));

            WallMoveRight(bigwallright1, new THREE.Vector3(0.5, 0, 0));
          }
        }

        if (numerofcabins == 1) {
          WallMove(bigwallleft1, new THREE.Vector3(0.45, 0, 0));
          WallMove(ref, new THREE.Vector3(1.71, 0, 0));
        }

        if (numerofwalls == 1) {
          gsap.to(ref2.current.position, {
            x: 0.0,
            duration: 1.5,
            ease: ease,
          });
          WallMove(bigwallleft1, new THREE.Vector3(1.3, 0, 0));
        }
      } else {
        BigLeftWalls([], [bigwallleft1, bigwallleft2]);
        BigRightWalls([], [bigwallright1, bigwallright2, bigwallright3]);

        SideWalls([ref, ref2, ref3], [ref5, ref6, ref7]);
        Rightsidewalls([ref14, ref15, ref16], [ref17, ref18, ref19]);
        WallMove(bigwallleft1, new THREE.Vector3(27, 0, 0));
        WallMove(bigwallleft2, new THREE.Vector3(27, 0, 0));
      }

      gsap.to(groundref.current.scale, {
        z: 1.29,
        x: 0.576,
        duration: duration,

        ease: ease,
      });
    }

    if (width == 4) {
      if (splitwall) {
        SideWalls([], [ref, ref2, ref3, ref5, ref6, ref7]);
        Rightsidewalls(
          [ref14, ref15, ref16, ref17],
          [ref14, ref15, ref16, ref17, ref18, ref19]
        );
        BigLeftWalls([bigwallleft1, bigwallleft2], [bigwallleft3]);
        BigRightWalls([bigwallright1, bigwallright2], [bigwallright3]);

        if (numerofwalls == 3) {
          WallMoveRight(ref18, new THREE.Vector3(27, 0, 0));
          WallMoveRight(bigwallright1, new THREE.Vector3(0.5, 0, 0));

          WallMoveRight(bigwallright2, new THREE.Vector3(2.207, 0, 0));
        }

        if (numerofwalls == 2 && numerofcabins == 1) {
          WallMove(bigwallleft1, new THREE.Vector3(1.31, 0, 0));
          WallMove(bigwallleft2, new THREE.Vector3(27, 0, 0));

          WallMove(ref, new THREE.Vector3(0.005, 0, 0));
          WallMove(ref2, new THREE.Vector3(2.565, 0, 0));
        }

        if (numerofwalls == 3 && numerofcabins == 1 && splitwall == true) {
          WallMove(bigwallleft1, new THREE.Vector3(1.316, 0, 0));
          WallMove(bigwallleft2, new THREE.Vector3(27, 0, 0));
          WallMove(ref, new THREE.Vector3(0.01, 0, 0));
          WallMove(ref2, new THREE.Vector3(2.578, 0, 0));
          WallMoveRight(bigwallright1, new THREE.Vector3(1.35, 0, 0));
          WallMoveRight(bigwallright2, new THREE.Vector3(27, 0, 0));
          WallMoveRight(ref18, new THREE.Vector3(2.654, 0, 0));
          WallMoveRight(ref19, new THREE.Vector3(0.088, 0, 0));
        }
      } else {
        SideWalls([ref, ref2, ref3, ref5], [ref6, ref7]);
        Rightsidewalls([ref14, ref15, ref16, ref17], [ref18, ref19]);
        BigLeftWalls([], [bigwallleft1, bigwallleft2, bigwallleft3]);
        BigRightWalls([], [bigwallright1, bigwallright2, bigwallright3]);
        WallMove(bigwallleft1, new THREE.Vector3(27, 0, 0));
        WallMove(bigwallleft2, new THREE.Vector3(27, 0, 0));
      }

      gsap.to(groundref.current.scale, {
        z: 1.718,
        x: 0.576,
        duration: duration,

        ease: ease,
      });
    }

    if (width == 5) {
      if (splitwall) {
        SideWalls([], [ref, ref2, ref3, ref5, ref6, ref7]);
        Rightsidewalls(
          [ref14, ref15, ref16, ref17, ref18],
          [ref14, ref15, ref16, ref17, ref19]
        );
        // BigLeftWalls([bigwallleft1,bigwallleft2],[bigwallleft3])
        BigRightWalls([bigwallright1, bigwallright2], [bigwallright3]);
        WallMove(bigwallleft1, new THREE.Vector3(0.45, 0, 0));
        WallMove(bigwallleft2, new THREE.Vector3(3.015, 0, 0));
        WallMove(bigwallleft3, new THREE.Vector3(27, 0, 0));
        WallMove(ref, new THREE.Vector3(1.71, 0, 0));

        if (numerofwalls == 3) {
          WallMoveRight(ref18, new THREE.Vector3(1.79, 0, 0));
          WallMoveRight(bigwallright2, new THREE.Vector3(3.05, 0, 0));

          if (numerofcabins == 1) {
            WallMoveRight(bigwallright2, new THREE.Vector3(2.19, 0, 0));
            WallMoveRight(bigwallright3, new THREE.Vector3(27, 0, 0));

            WallMoveRight(ref18, new THREE.Vector3(3.495, 0, 0));
          }
        }

        if (numerofcabins == 1) {
          WallMove(bigwallleft1, new THREE.Vector3(0.45, 0, 0));
          WallMove(bigwallleft2, new THREE.Vector3(2.16, 0, 0));
          BigRightWalls([bigwallright1, bigwallright2], [bigwallright3]);

          WallMove(ref, new THREE.Vector3(3.42, 0, 0));
        }
      } else {
        SideWalls([ref, ref2, ref3, ref5, ref6], [ref7]);
        Rightsidewalls([ref14, ref15, ref16, ref17, ref18], [ref19]);
        BigLeftWalls([], [bigwallleft1, bigwallleft2, bigwallleft3]);
        BigRightWalls([], [bigwallright1, bigwallright2, bigwallright3]);

        WallMove(bigwallleft1, new THREE.Vector3(27, 0, 0));
        WallMove(bigwallleft2, new THREE.Vector3(27, 0, 0));
      }

      gsap.to(groundref.current.scale, {
        z: 2.15,
        x: 0.576,
        duration: duration,

        ease: ease,
      });
    }

    if (width == 6) {
      if (splitwall) {
        SideWalls([], [ref, ref2, ref3, ref5, ref6, ref7]);
        Rightsidewalls(
          [ref14, ref15, ref16, ref17, ref18, ref19],
          [ref14, ref15, ref16, ref17, ref18, ref19]
        );
        BigLeftWalls([bigwallleft1, bigwallleft2, bigwallleft3], []);
        BigRightWalls([bigwallright1, bigwallright2, bigwallright3], []);

        if (numerofwalls == 3 && numerofcabins == 0) {
          WallMoveRight(bigwallright3, new THREE.Vector3(2.2, 0, 0));
          WallMoveRight(bigwallright2, new THREE.Vector3(3.91, 0, 0));
        }

        if (numerofwalls == 3 && numerofcabins == 1) {
          WallMove(bigwallleft1, new THREE.Vector3(1.32, 0, 0));
          WallMove(bigwallleft3, new THREE.Vector3(27, 0, 0));
          WallMove(bigwallleft2, new THREE.Vector3(3.04, 0, 0));

          WallMove(ref, new THREE.Vector3(0.01, 0, 0));
          WallMove(ref2, new THREE.Vector3(4.302, 0, 0));

          WallMoveRight(bigwallright3, new THREE.Vector3(27, 0, 0));
          WallMoveRight(bigwallright2, new THREE.Vector3(3.056, 0, 0));
          WallMoveRight(bigwallright1, new THREE.Vector3(1.355, 0, 0));
          WallMoveRight(ref14, new THREE.Vector3(4.355, 0, 0));
          WallMoveRight(ref15, new THREE.Vector3(0.1, 0, 0));
        }

        if (numerofwalls == 2 && numerofcabins == 1) {
          WallMove(bigwallleft1, new THREE.Vector3(0.46, 0, 0));
          WallMove(bigwallleft2, new THREE.Vector3(2.17, 0, 0));
          WallMove(bigwallleft3, new THREE.Vector3(27, 0, 0));

          WallMove(ref, new THREE.Vector3(3.435, 0, 0));

          WallMove(ref2, new THREE.Vector3(4.29, 0, 0));
        }
      } else {
        SideWalls([ref, ref2, ref3, ref5, ref6, ref7], []);
        Rightsidewalls([ref14, ref15, ref16, ref17, ref18, ref19], []);
        BigLeftWalls([], [bigwallleft1, bigwallleft2, bigwallleft3]);
        BigRightWalls([], [bigwallright1, bigwallright2, bigwallright3]);
      }

      gsap.to(groundref.current.scale, {
        z: 2.58,
        x: 0.576,
        duration: duration,

        ease: ease,
      });
    }

    if (length == 1) {
      gsap.to(groundref.current.scale, {
        x: 0.52,
        duration: duration,

        ease: ease,
      });

      if (splitwall) {
        Show([ref8], [ref9, ref10, ref11, ref12, ref13]);
        BigFrontWalls([], [bigwallfront1, bigwallfront2, bigwallfront3]);
      } else {
        Show([ref8], [ref9, ref10, ref11, ref12, ref13]);
        BigFrontWalls([], [bigwallfront1, bigwallfront2, bigwallfront3]);
      }
    }

    if (length == 2) {
      gsap.to(groundref.current.scale, {
        x: 0.947,
        duration: duration,

        ease: ease,
      });

      if (splitwall) {
        Show([ref8, ref9], [ref8, ref9, ref10, ref11, ref12, ref13]);
        BigFrontWalls([bigwallfront1], [bigwallfront2, bigwallfront3]);

        if (numerofcabins == 1) {
          gsap.to(ref8.current.position, {
            x: (width - 0.4) * 0.862,
            z: 0.46,
            duration: 1.5,
            ease: ease,
          });

          gsap.to(ref9.current.position, {
            x: (width - 0.4) * 0.862,
            z: 1.315,
            duration: 1.5,
            ease: ease,
          });

          WallMove(bigwallfront1, new THREE.Vector3(27, 0, 0));
        }

        if (numerofwalls == 3 && numerofcabins == 0) {
          WallMoveFront(bigwallfront1, new THREE.Vector3(0, 0, 27));
          WallMoveFront(ref8, new THREE.Vector3(0, 0, 0.455));
          WallMoveFront(ref9, new THREE.Vector3(0, 0, 1.31));
        }

        // WallMoveFront(ref8,new THREE.Vector3(1,0,0))
      } else {
        Show([ref8, ref9], [ref10, ref11, ref12, ref13]);
        BigFrontWalls([], [bigwallfront1, bigwallfront2, bigwallfront3]);
      }
    }

    if (length == 3) {
      gsap.to(groundref.current.scale, {
        x: 1.376,
        duration: duration,

        ease: ease,
      });

       Counter2(true,new THREE.Vector3( ( (width * 0.88) - 1 ) ,0,2.44), new THREE.Vector3(0,-Math.PI,-Math.PI * 0.5))

      if (splitwall) {
        Show([ref8, ref9, ref10], [ref8, ref9, ref11, ref12, ref13]);

        if (numerofwalls > 1) {
          BigFrontWalls([bigwallfront1], [bigwallfront2, bigwallfront3]);
          WallMoveFront(bigwallfront1, new THREE.Vector3(0, 0, 0.915));
          WallMoveFront(ref10, new THREE.Vector3(0, 0, 2.175));
        }

        if (numerofwalls == 2) {
          WallMoveFront(bigwallfront1, new THREE.Vector3(0, 0, 1.79));
          WallMoveFront(ref10, new THREE.Vector3(0, 0, 0.485));
        }

        if (numerofwalls == 3 && numerofcabins == 1) {
          WallMoveFront(bigwallfront1, new THREE.Vector3(0, 0, 27));
          WallMoveFront(ref10, new THREE.Vector3(0, 0, 2.175));
          WallMoveFront(ref8, new THREE.Vector3(0, 0, 0.464));
          WallMoveFront(ref9, new THREE.Vector3(0, 0, 1.322));

          if (bigcabin == true) {
            WallMoveFront(bigwallfront1, new THREE.Vector3(0, 0, 1.77));
            WallMoveFront(ref10, new THREE.Vector3(0, 0, 27));
            WallMoveFront(ref8, new THREE.Vector3(0, 0, 0.464));
            WallMoveFront(ref9, new THREE.Vector3(0, 0, 27));
          }
        }
      } else {
        Show([ref8, ref9, ref10], [ref11, ref12, ref13]);
        BigFrontWalls([], [bigwallfront1, bigwallfront2, bigwallfront3]);
      }
    }

    if (length == 4) {
      gsap.to(groundref.current.scale, {
        x: 1.806,
        duration: duration,

        ease: ease,
      });

         Counter2(true,new THREE.Vector3( ( (width * 0.88) - 1 ),0,3.3), new THREE.Vector3(0,-Math.PI,-Math.PI * 0.5))

      if (splitwall) {
        Show(
          [ref8, ref9, ref10, ref11],
          [ref8, ref9, ref10, ref11, ref12, ref13]
        );
        BigFrontWalls([bigwallfront1, bigwallfront2], [bigwallfront3]);

        if (numerofwalls == 2 && numerofcabins == 1 && bigcabin == false) {
          WallMoveFront(bigwallfront1, new THREE.Vector3(0, 0, 1.78));
          WallMoveFront(bigwallfront2, new THREE.Vector3(0, 0, 27));

          WallMoveFront(ref8, new THREE.Vector3(0, 0, 0.47));
          WallMoveFront(ref9, new THREE.Vector3(0, 0, 3.04));
        }

        if (
          numerofwalls == 3 &&
          numerofcabins == 1 &&
          bigcabin == false &&
          splitwall == true
        ) {
          WallMoveFront(bigwallfront2, new THREE.Vector3(0, 0, 27));
          WallMoveFront(bigwallfront1, new THREE.Vector3(0, 0, 2.63));
          WallMoveFront(ref8, new THREE.Vector3(0, 0, 1.325));
          WallMoveFront(ref9, new THREE.Vector3(0, 0, 0.47));
        }
      } else {
        Show([ref8, ref9, ref10, ref11], [ref12, ref13]);
        BigFrontWalls([], [bigwallfront1, bigwallfront2, bigwallfront3]);
      }
    }

    if (length == 5) {
      gsap.to(groundref.current.scale, {
        x: 2.236,
        duration: duration,

        ease: ease,
      });

      if (splitwall) {
        Show(
          [ref8, ref9, ref10, ref11, ref13],
          [ref8, ref9, ref10, ref11, ref12]
        );
        BigFrontWalls([bigwallfront1, bigwallfront2], [bigwallfront3]);

        if (numerofwalls > 1) {
          WallMoveFront(bigwallfront1, new THREE.Vector3(0, 0, 0.912));
          WallMoveFront(bigwallfront2, new THREE.Vector3(0, 0, 3.479));

          WallMoveFront(ref13, new THREE.Vector3(0, 0, 2.172));
        }

        if (numerofwalls == 2 && numerofcabins == 1 && bigcabin == false) {
          WallMoveFront(bigwallfront1, new THREE.Vector3(0, 0, 1.78));
          WallMoveFront(bigwallfront2, new THREE.Vector3(0, 0, 3.49));

          WallMoveFront(ref8, new THREE.Vector3(0, 0, 0.47));
          WallMoveFront(ref9, new THREE.Vector3(0, 0, 27));
          WallMoveFront(ref13, new THREE.Vector3(0, 0, 27));
        }

        if (
          numerofwalls == 3 &&
          numerofcabins == 1 &&
          bigcabin == false &&
          splitwall == true
        ) {
          WallMoveFront(bigwallfront2, new THREE.Vector3(0, 0, 3.49));
          WallMoveFront(bigwallfront1, new THREE.Vector3(0, 0, 1.78));
          WallMoveFront(ref13, new THREE.Vector3(0, 0, 0.478));
        }
      } else {
        Show([ref8, ref9, ref10, ref11, ref12], [ref13]);
        BigFrontWalls([], [bigwallfront1, bigwallfront2, bigwallfront3]);
      }
    }

    if (length == 6) {
      gsap.to(groundref.current.scale, {
        x: 2.664,
        duration: duration,

        ease: ease,
      });

      //   Show([ref8,ref9,ref10,ref11,ref12,ref13],[])

      if (splitwall) {
        Show(
          [ref8, ref9, ref10, ref11, ref12, ref13],
          [ref8, ref9, ref10, ref11, ref12, ref13]
        );
        BigFrontWalls([bigwallfront1, bigwallfront2, bigwallfront3], []);

        if (numerofwalls == 2 && numerofcabins == 1 && bigcabin == false) {
          WallMoveFront(bigwallfront1, new THREE.Vector3(0, 0, 27));
          // WallMoveFront(bigwallfront2,new THREE.Vector3(0,0,3.49))
          WallMoveFront(ref8, new THREE.Vector3(0, 0, 0.47));
          WallMoveFront(ref9, new THREE.Vector3(0, 0, 1.325));
        }

        if (
          numerofwalls == 3 &&
          numerofcabins == 1 &&
          bigcabin == false &&
          splitwall == true
        ) {
          WallMoveFront(bigwallfront2, new THREE.Vector3(0, 0, 4.35));
          WallMoveFront(bigwallfront3, new THREE.Vector3(0, 0, 27));
          WallMoveFront(bigwallfront1, new THREE.Vector3(0, 0, 2.637));
          WallMoveFront(ref13, new THREE.Vector3(0, 0, 1.33));
          WallMoveFront(ref8, new THREE.Vector3(0, 0, 0.478));
        }
      } else {
        Show([ref8, ref9, ref10, ref11, ref12, ref13], []);
        BigFrontWalls([], [bigwallfront1, bigwallfront2, bigwallfront3]);
      }
    }

    if (height == 2) {
      gsap.to(BigCabinwall.current.scale, {
        x: 1,
        duration: duration,

        ease: ease,
      });

      sidewalls.forEach((el, i) => {
        gsap.to(el.current.scale, {
          z: 0.001,
          duration: duration,

          ease: ease,
        });
      });

      rightsidewalls.forEach((el, i) => {
        gsap.to(el.current.scale, {
          z: 0.001,
          duration: duration,

          ease: ease,
        });
      });

      frontwalls.forEach((el, i) => {
        gsap.to(el.current.scale, {
          z: 0.001,
          duration: duration,

          ease: ease,
        });
      });

      cabinwalls.forEach((el, i) => {
        gsap.to(el.current.scale, {
          z: 0.001,
          duration: duration,

          ease: ease,
        });
      });

      bigwallsleft.forEach((el, i) => {
        gsap.to(el.current.scale, {
          x: 1,
          duration: duration,

          ease: ease,
        });
      });

      bigwallsright.forEach((el, i) => {
        gsap.to(el.current.scale, {
          x: 1,
          duration: duration,

          ease: ease,
        });
      });

      bigwallsfront.forEach((el, i) => {
        gsap.to(el.current.scale, {
          x: 1,
          duration: duration,

          ease: ease,
        });
      });
    }

    if (height == 2.25) {
      gsap.to(BigCabinwall.current.scale, {
        x: 1.1,
        duration: duration,

        ease: ease,
      });

      sidewalls.forEach((el, i) => {
        gsap.to(el.current.scale, {
          z: 0.0011,
          duration: duration,

          ease: ease,
        });
      });

      rightsidewalls.forEach((el, i) => {
        gsap.to(el.current.scale, {
          z: 0.0011,
          duration: duration,

          ease: ease,
        });
      });

      frontwalls.forEach((el, i) => {
        gsap.to(el.current.scale, {
          z: 0.0011,
          duration: duration,

          ease: ease,
        });
      });

      cabinwalls.forEach((el, i) => {
        gsap.to(el.current.scale, {
          z: 0.0011,
          duration: duration,

          ease: ease,
        });
      });

      bigwallsleft.forEach((el, i) => {
        gsap.to(el.current.scale, {
          x: 1.1,
          duration: duration,

          ease: ease,
        });
      });

      bigwallsright.forEach((el, i) => {
        gsap.to(el.current.scale, {
          x: 1.1,
          duration: duration,

          ease: ease,
        });
      });

      bigwallsfront.forEach((el, i) => {
        gsap.to(el.current.scale, {
          x: 1.1,
          duration: duration,

          ease: ease,
        });
      });
    }

    if (height == 2.5) {
      gsap.to(BigCabinwall.current.scale, {
        x: 1.204,
        duration: duration,

        ease: ease,
      });

      sidewalls.forEach((el, i) => {
        gsap.to(el.current.scale, {
          z: 0.0012,
          duration: duration,

          ease: ease,
        });
      });

      rightsidewalls.forEach((el, i) => {
        gsap.to(el.current.scale, {
          z: 0.0012,
          duration: duration,

          ease: ease,
        });
      });

      frontwalls.forEach((el, i) => {
        gsap.to(el.current.scale, {
          z: 0.0012,
          duration: duration,

          ease: ease,
        });
      });

      cabinwalls.forEach((el, i) => {
        gsap.to(el.current.scale, {
          z: 0.0012,
          duration: duration,

          ease: ease,
        });
      });

      bigwallsleft.forEach((el, i) => {
        gsap.to(el.current.scale, {
          x: 1.2,
          duration: duration,

          ease: ease,
        });
      });

      bigwallsright.forEach((el, i) => {
        gsap.to(el.current.scale, {
          x: 1.2,
          duration: duration,

          ease: ease,
        });
      });

      bigwallsfront.forEach((el, i) => {
        gsap.to(el.current.scale, {
          x: 1.2,
          duration: duration,

          ease: ease,
        });
      });
    }

    if (numerofwalls == 1) {
      if (width == 1 && numerofwalls == 1) {
        Counter1(
          true,
          new THREE.Vector3(0.045, 0, length - (0.17 + length * 0.13)),
          new THREE.Vector3(0, -Math.PI * 0.995, -Math.PI * 0.5)
        );
        Counter2(
          true,
          new THREE.Vector3(0.2, 0, length - (0.17 + length * 0.13)),
          new THREE.Vector3(0, -Math.PI * 0.995, -Math.PI * 0.5)
        );
      } else if (
        width == 2 &&
        numerofwalls == 1 &&
        counterdata[2].state !== 0
      ) {
        Counter1(
          true,
          new THREE.Vector3(numberofcounters == 2 ? 0.045 : 0.51, 0, length - (0.17 + length * 0.13)),
          new THREE.Vector3(0, -Math.PI * 0.995, -Math.PI * 0.5)
        );
        Counter2(
          true,
          new THREE.Vector3(0.902, 0, length - (0.17 + length * 0.13)),
          new THREE.Vector3(0, -Math.PI * 0.995, -Math.PI * 0.5)
        );
      } else if (width == 3 && numerofwalls == 1) {
        Counter1(
          true,
          new THREE.Vector3(numberofcounters == 2 ? 0.045 : 0.92, 0, length - (0.17 + length * 0.13)),
          new THREE.Vector3(0, -Math.PI * 0.995, -Math.PI * 0.5)
        );
        Counter2(
          true,
          new THREE.Vector3(1.765, 0, length - (0.17 + length * 0.13)),
          new THREE.Vector3(0, -Math.PI * 0.995, -Math.PI * 0.5)
        );
      } else if (width == 4 && numerofwalls == 1) {
        Counter1(
          true,
          new THREE.Vector3(numberofcounters == 2 ? 0.045 : 1.3, 0, length - (0.17 + length * 0.13)),
          new THREE.Vector3(0, -Math.PI * 0.995, -Math.PI * 0.5)
        );
        Counter2(
          true,
          new THREE.Vector3(2.624, 0, length - (0.17 + length * 0.13)),
          new THREE.Vector3(0, -Math.PI * 0.995, -Math.PI * 0.5)
        );
      } else if (width == 5 && numerofwalls == 1) {
        Counter1(
          true,
          new THREE.Vector3(numberofcounters == 2 ? 0.045 : 1.78, 0, length - (0.17 + length * 0.13)),
          new THREE.Vector3(0, -Math.PI * 0.995, -Math.PI * 0.5)
        );
        Counter2(
          true,
          new THREE.Vector3(3.488, 0, length - (0.17 + length * 0.13)),
          new THREE.Vector3(0, -Math.PI * 0.995, -Math.PI * 0.5)
        );
      } else if (width == 6 && numerofwalls == 1) {
        Counter1(
          true,
          new THREE.Vector3(numberofcounters == 2 ? 0.045 : 2.27, 0, length - (0.17 + length * 0.13)),
          new THREE.Vector3(0, -Math.PI * 0.995, -Math.PI * 0.5)
        );
        Counter2(
          true,
          new THREE.Vector3(4.35, 0, length - (0.17 + length * 0.13)),
          new THREE.Vector3(0, -Math.PI * 0.995, -Math.PI * 0.5)
        );
      } else {
        Counter1(
          true,
          new THREE.Vector3(0.045, 0, length - (0.17 + length * 0.13)),
          new THREE.Vector3(0, -Math.PI * 0.995, -Math.PI * 0.5)
        );
      }

      // Counter2(true,new THREE.Vector3(  width - (0.95 + (width * 0.13) ) ,0,  length - (0.17 + (length * 0.13) ) ), new THREE.Vector3(0,-Math.PI * 0.997,-Math.PI * 0.5))
    }

    if (numerofwalls == 2) {
      // setcounterdata((prevState) => {
      //     const newState = [...prevState]; // Create a copy of the state array
      //     if (newState.length >= 3) { // Check if the array has at least 3 items
      //       newState[2] = { ...newState[2], state: 1 }; // Update the state of the third item
      //     }
      //     return newState; // Return the updated state
      //   });
      
      if(width  >1 && length >1 && numerofwalls == 2 && numerofcabins == 0){
        Counter1(
          true,
          new THREE.Vector3(numberofcounters == 2 ? -0.19 : 0.04, 0,  numberofcounters == 2 ? 0.499 :  length - (0.37 + length * 0.1365)),
          new THREE.Vector3( 0, numberofcounters == 2 ? -Math.PI * 1.5 : -Math.PI * 1.25, -Math.PI * 0.5)
        );
      }
      
      if (width == 2 && length == 3 && numerofcabins == 1) {
        Counter1(
          true,
          new THREE.Vector3(0.05, 0, 2.23),
          new THREE.Vector3(0, -Math.PI * 1.25, -Math.PI * 0.5)
        );
        
      } else if (
        length > 1 &&
        length < 5 &&
        width > 2 &&
        width < 4 &&
        numerofcabins == 1
      ) {
        Counter1(
          true,
          new THREE.Vector3(0.05, 0, length - (0.37 + length * 0.1365)),
          new THREE.Vector3(0, -Math.PI * 1.25, -Math.PI * 0.5)
        );
      } else if (length > 4 && length < 7 && width > 1 && numerofcabins == 1) {
        Counter1(
          true,
          new THREE.Vector3(-0.18, 0, length - (1.25 + length * 0.1365)),
          new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
        );
        Counter2(
          true,
          new THREE.Vector3(
            width - (0.868 + width * 0.1365),
            0,
            length - (0.17 + length * 0.13)
          ),
          new THREE.Vector3(0, -Math.PI * 0.997, -Math.PI * 0.5)
        );
      } else if (length == 2 && width > 3 && width < 7 && numerofcabins == 1) {
        Counter2(
          true,
          new THREE.Vector3(
            width - (1.92 + width * 0.1365),
            0,
            length - (0.15 + length * 0.13)
          ),
          new THREE.Vector3(0, -Math.PI * 0.997, -Math.PI * 0.5)
        );
      } else {
        // Counter1(
        //   true,
        //   new THREE.Vector3(-0.19, 0, 0.499),
        //   new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
        // );
        Counter2(
          true,
          new THREE.Vector3(
            width - (0.868 + width * 0.1365),
            0,
            length - (0.17 + length * 0.13)
          ),
          new THREE.Vector3(0, -Math.PI * 0.997, -Math.PI * 0.5)
        );
      }
    }

    if(width == 2 && length == 3 && numerofwalls == 2 && numerofcabins == 1){
      Counter1(
        true,
        new THREE.Vector3(0.05, 0, length - (0.37 + length * 0.1365)),
        new THREE.Vector3(0, -Math.PI * 1.25, -Math.PI * 0.5)
      );
    }

    
    if(width == 2 && length == 4 && numerofwalls == 2 && numberofcounters == 2 && numerofcabins == 1 ){
      Counter1(
        true,
        new THREE.Vector3( width - (1.92 + width * 0.1365) , 0, length - (1.2 + length * 0.1365)),
        new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
      );
      Counter2(
        true,
        new THREE.Vector3( width - (1.92 + width * 0.1365) , 0, length - (0.349 + length * 0.1365)),
        new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
      );

    }

    if(width == 2 && length == 5 && numerofwalls == 2 && numberofcounters == 2 && numerofcabins == 1 ){
      Counter1(
        true,
        new THREE.Vector3( width - (1.92 + width * 0.1365) , 0, length - (1.2 + length * 0.1365)),
        new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
      );
      Counter2(
        true,
        new THREE.Vector3( width - (1.92 + width * 0.1365) , 0, length - (0.349 + length * 0.1365)),
        new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
      );

    }

    if(width == 2 && length == 6 && numerofwalls == 2 && numberofcounters == 2 && numerofcabins == 1 ){
      Counter1(
        true,
        new THREE.Vector3( width - (1.92 + width * 0.1365) , 0, length - (1.2 + length * 0.1365)),
        new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
      );
      Counter2(
        true,
        new THREE.Vector3( width - (1.92 + width * 0.1365) , 0, length - (0.349 + length * 0.1365)),
        new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
      );

    }

    if(width == 4 && length == 2 && numerofwalls == 2 && numberofcounters == 2 && numerofcabins == 1 ){
      Counter1(
        true,
        new THREE.Vector3( width - (3.425 + width * 0.1365) , 0, length - (0.124 + length * 0.1365)),
        new THREE.Vector3(0, -Math.PI * 1, -Math.PI * 0.5)
      );
      Counter2(
        true,
        new THREE.Vector3( width - (2.572 + width * 0.1365) , 0, length - (0.124 + length * 0.1365)),
        new THREE.Vector3(0, -Math.PI * 1, -Math.PI * 0.5)
      );

    }

    if(width == 5 && length == 2 && numerofwalls == 2 && numberofcounters == 2 && numerofcabins == 1 ){
      Counter1(
        true,
        new THREE.Vector3( width - (4.29 + width * 0.1365) , 0, length - (0.124 + length * 0.1365)),
        new THREE.Vector3(0, -Math.PI * 1, -Math.PI * 0.5)
      );
      Counter2(
        true,
        new THREE.Vector3( width - (3.435 + width * 0.1365) , 0, length - (0.124 + length * 0.1365)),
        new THREE.Vector3(0, -Math.PI * 1, -Math.PI * 0.5)
      );

    }

    if(width == 6 && length == 2 && numerofwalls == 2 && numberofcounters == 2 && numerofcabins == 1 ){
      Counter1(
        true,
        new THREE.Vector3( width - (5.15+ width * 0.1365) , 0, length - (0.124 + length * 0.1365)),
        new THREE.Vector3(0, -Math.PI * 1, -Math.PI * 0.5)
      );
      Counter2(
        true,
        new THREE.Vector3( width - (4.3+ width * 0.1365) , 0, length - (0.124 + length * 0.1365)),
        new THREE.Vector3(0, -Math.PI * 1, -Math.PI * 0.5)
      );

    }

    
 
    if(width > 2 && length >2 && numerofwalls == 2 && numberofcounters == 2 && numerofcabins == 1 ){
       Counter1(
          true,
          new THREE.Vector3(-0.19, 0, 0.499),
          new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
        );
        Counter2(
          true,
          new THREE.Vector3(
            width - (0.868 + width * 0.1365),
            0,
            length - (0.17 + length * 0.13)
          ),
          new THREE.Vector3(0, -Math.PI * 0.997, -Math.PI * 0.5)
        );

    }

    if(numerofwalls == 2 && numerofcabins == 1 && numberofcounters == 1){
      Counter1(
        true,
        new THREE.Vector3(0.05, 0, length - (0.37 + length * 0.1365)),
        new THREE.Vector3(0, -Math.PI * 1.25, -Math.PI * 0.5)
      );
    }



    if (numerofwalls == 3) {

      if(numberofcounters == 1){

        if(length == 3){
          Counter1(
            true,
            new THREE.Vector3(-0.19, 0, length - (1.25 + length * 0.1365) ),
            new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
          );
         }
  
         if(length == 4){
          Counter1(
            true,
            new THREE.Vector3(-0.19, 0, length - (1.5 + length * 0.1365) ),
            new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
          );
         }
  
         if(length == 5){
          Counter1(
            true,
            new THREE.Vector3(-0.19, 0, length - (2.08 + length * 0.1365) ),
            new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
          );
         }
  
         if(length == 6){
          Counter1(
            true,
            new THREE.Vector3(-0.19, 0, length - (2.47 + length * 0.1365) ),
            new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
          );
         }

      }

      if(numerofcabins == 1){

        if(width < 3){
          Counter1(
            true,
            new THREE.Vector3(-0.19, 0, length - (1.25 + length * 0.1365) ),
            new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
          );
        }

      }

      else {
          Counter1(
          true,
          new THREE.Vector3(-0.19, 0, 0.497 ),
          new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
        );
        Counter2(
          true,
          new THREE.Vector3(-0.19, 0, length - (0.389 + length * 0.1365)),
          new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
        );
      }

      

      if (numerofcabins == 1) {
        if (length > 2 && length < 4 && width > 3 && width < 7) {
          Counter1(
            true,
            new THREE.Vector3(-0.19, 0, length - (0.389 + length * 0.1365)),
            new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
          );
          Counter2(
            true,
            new THREE.Vector3(0.433, 0, length - (1.01 + length * 0.1365)),
            new THREE.Vector3(0, -Math.PI * 0.0, -Math.PI * 0.5)
          );
        } else {
          Counter1(
            true,
            new THREE.Vector3(-0.19, 0, length - (0.389 + length * 0.1365)),
            new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
          );
          Counter2(
            true,
            new THREE.Vector3(-0.19, 0, length - (1.242 + length * 0.1365)),
            new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
          );
        }
      } else {
        // Counter1(
        //   true,
        //   new THREE.Vector3(-0.19, 0, length - (1.242 + length * 0.1365) ),
        //   new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
        // );
        // Counter2(
        //   true,
        //   new THREE.Vector3(-0.19, 0, length - (0.389 + length * 0.1365)),
        //   new THREE.Vector3(0, -Math.PI * 1.5, -Math.PI * 0.5)
        // );
      }
    }

    gsap.to(groupref.current.position, {
      x: isMobile ? -width / 3 : -width / 2.1,
      y: isMobile ? 2 : -0.2,
      z: -length / 2.1,
      duration: duration,

      ease: ease,
    });

    if (numerofcabins == 1 && numerofwalls == 2) {
      gsap.to(Cabin1.current.position, {
        x: 0.54 + 0.86 * (width - 2),
        y: 0,
        z: bigcabin && splitwall ? 26 : 0.436,
        duration: duration,

        ease: ease,
      });

      if (splitwall) {
        gsap.to(BigCabinwall.current.position, {
          x: 0.54 + 0.86 * (width - 2),
          y: 0,
          z: bigcabin ? 0.845 : 26,
          duration: duration,

          ease: ease,
        });
      } else {
        gsap.to(BigCabinwall.current.position, {
          x: -24,
          y: 0,
          z: 0,
          duration: duration,

          ease: ease,
        });
      }

      gsap.to(Cabin2.current.position, {
        x: 0.54 + 0.86 * (width - 2),
        y: 0,
        z: bigcabin == false || splitwall ? 24 : 1.215,
        duration: duration,

        ease: ease,
      });

      gsap.to(Cabinwall.current.position, {
        x: 0.929 + 0.86 * (width - 2),
        y: 0,
        z: bigcabin ? 1.705 : 0.933,
        duration: duration,

        ease: ease,
      });
    }

    if (numerofcabins == 1 && numerofwalls == 3) {
      gsap.to(Cabin1.current.position, {
        x: 0.54 + 0.86 * (width - 2),
        y: 0,
        z: splitwall ? 26 : 0.436,
        duration: duration,

        ease: ease,
      });

      if (splitwall) {
        gsap.to(BigCabinwall.current.position, {
          x: 0.54 + 0.86 * (width - 2),
          y: 0,
          z: bigcabin ? 0.845 : 26,
          duration: duration,

          ease: ease,
        });
      } else {
        gsap.to(BigCabinwall.current.position, {
          x: -24,
          y: 0,
          z: 0,
          duration: duration,

          ease: ease,
        });
      }

      gsap.to(Cabin2.current.position, {
        x: 0.54 + 0.86 * (width - 2),
        y: 0,
        z: bigcabin == false || splitwall ? 24 : 1.22,
        duration: duration,

        ease: ease,
      });

      gsap.to(Cabinwall.current.position, {
        x: 0.925 + 0.86 * (width - 2),
        y: 0,
        z: bigcabin ? 1.712 : 0.86,
        duration: duration,

        ease: ease,
      });
    }

    if (length < 3) {
      gsap.to(Cabin1.current.position, {
        x: 0.54 + 0.86 * (width - 2),
        y: 0,
        z: bigcabin ? 26 : 0.4,
        duration: duration,

        ease: ease,
      });

      gsap.to(Cabin2.current.position, {
        x: -24,
        y: 0,
        z: 1.1985,
        duration: duration,

        ease: ease,
      });

      gsap.to(Cabinwall.current.position, {
        x: 0.93 + 0.86 * (width - 2),
        y: 0,
        z: bigcabin ? 1.7 : 0.872,
        duration: duration,

        ease: ease,
      });
    }

    if (width == 1 && length == 1) {
      gsap.to(Cabin1.current.position, {
        x: -24,
        y: 0,
        z: 0,
        duration: duration,

        ease: ease,
      });

      gsap.to(BigCabinwall.current.position, {
        x: -24,
        y: 0,
        z: 0,
        duration: duration,

        ease: ease,
      });

      gsap.to(Cabin2.current.position, {
        x: -24,
        y: 0,
        z: 1.325,
        duration: duration,

        ease: ease,
      });

      gsap.to(Cabinwall.current.position, {
        x: -24,
        y: 0,
        z: 1.86,
        duration: duration,

        ease: ease,
      });
    }

    if (numerofwalls < 2 || numerofcabins == 0 || width < 2) {
      gsap.to(Cabin1.current.position, {
        x: -24,
        y: 0,
        z: 0,
        duration: duration,

        ease: ease,
      });

      gsap.to(BigCabinwall.current.position, {
        x: -24,
        y: 0,
        z: 0,
        duration: duration,

        ease: ease,
      });

      gsap.to(Cabin2.current.position, {
        x: -24,
        y: 0,
        z: 1.1985,
        duration: duration,

        ease: ease,
      });

      gsap.to(Cabinwall.current.position, {
        x: -24,
        y: 0,
        z: 1.86,
        duration: duration,

        ease: ease,
      });
    }

    if (width > 2 && length < 3 && numerofcabins == 1 && numerofwalls == 3) {
      gsap.to(Cabin1.current.position, {
        x: 0.54 + 0.86 * (width - 2),
        y: 0,
        z: 0.455,

        duration: duration,

        ease: ease,
      });

      gsap.to(Cabin2.current.position, {
        x: 0.54 + 0.86 * (width - 2),
        y: 0,
        z: 1.3,
        duration: duration,

        ease: ease,
      });

      gsap.to(Cabin2.current.scale, {
        y: 0.00103,
        duration: duration,
        ease: ease,
      });

      gsap.to(Cabin1.current.scale, {
        y: 0.00096,
        duration: duration,
        ease: ease,
      });

      gsap.to(Cabinwall.current.position, {
        x: -24,
        y: 0,
        z: 1.86,
        duration: duration,

        ease: ease,
      });
    } else {
      gsap.to(Cabin2.current.scale, {
        y: 0.00092,
        duration: duration,
        ease: ease,
      });

      gsap.to(Cabin1.current.scale, {
        y: 0.00092,
        duration: duration,
        ease: ease,
      });
    }

    if (numerofwalls == 1) {
      textref1.current.text =
        width == 1 ? getUnit(green / 100) : getUnit(green / 100);
      textref2.current.text = getUnit(green / 100);
      textref3.current.text = getUnit(green / 100);
      textref4.current.text = getUnit(green / 100);
      textref5.current.text = getUnit(green / 100);
      textref6.current.text = getUnit(green / 100);
      textref19.current.text = getUnit(red / 100);
      textref20.current.text = getUnit(red / 100);
      textref21.current.text = getUnit(red / 100);
    }

    if (numerofwalls == 2 && numerofcabins == 0) {
      textref1.current.text = getUnit(green / 100);
      textref2.current.text = getUnit(orange / 100);
      textref3.current.text = getUnit(orange / 100);
      textref4.current.text = getUnit(orange / 100);
      textref7.current.text =
        length == 1 ? getUnit(green / 100) : getUnit(orange / 100);
      textref8.current.text =
        length == 2 ? getUnit(green / 100) : getUnit(orange / 100);
      textref9.current.text =
        length == 3 ? getUnit(green / 100) : getUnit(orange / 100);
      textref10.current.text =
        length == 4 ? getUnit(green / 100) : getUnit(orange / 100);
      textref11.current.text =
        length == 5 ? getUnit(green / 100) : getUnit(orange / 100);
      textref12.current.text =
        length == 6 ? getUnit(green / 100) : getUnit(orange / 100);
    }

    if (numerofwalls == 2 && numerofcabins == 1 && bigcabin == false) {
      textref1.current.text = getUnit(green / 100);
      textref2.current.text = getUnit(orange / 100);
      textref4.current.text = getUnit(orange / 100);
      textref5.current.text = getUnit(orange / 100);
      textref6.current.text = getUnit(orange / 100);
      textref7.current.text =
        length == 1 ? getUnit(green / 100) : getUnit(orange / 100);
      textref8.current.text =
        length < 4 ? getUnit(green / 100) : getUnit(orange / 100);

      textref9.current.text =
        length == 0 ? getUnit(green / 100) : getUnit(orange / 100);
      textref10.current.text =
        length == 4 ? getUnit(green / 100) : getUnit(orange / 100);
      textref11.current.text =
        length == 5 ? getUnit(green / 100) : getUnit(orange / 100);
      textref12.current.text =
        length == 6 ? getUnit(green / 100) : getUnit(orange / 100);
    }

    if (numerofwalls == 2 && numerofcabins == 1 && bigcabin == true) {
      textref1.current.text = getUnit(green / 100);
      textref2.current.text = getUnit(orange / 100);
      textref3.current.text = getUnit(orange / 100);
      textref4.current.text = getUnit(orange / 100);
      textref6.current.text = getUnit(orange / 100);
      textref7.current.text =
        length == 1 ? getUnit(green / 100) : getUnit(orange / 100);
      textref8.current.text =
        length < 4 ? getUnit(green / 100) : getUnit(orange / 100);

      textref9.current.text =
        length == 0 ? getUnit(green / 100) : getUnit(orange / 100);
      textref10.current.text =
        length == 4 ? getUnit(green / 100) : getUnit(orange / 100);
      textref11.current.text =
        length == 5 ? getUnit(green / 100) : getUnit(orange / 100);
      textref12.current.text =
        length == 6 ? getUnit(green / 100) : getUnit(orange / 100);

      // turquoise
      textref19.current.text = getUnit(red / 100);
      textref20.current.text = getUnit(turquoise / 100);
      textref22.current.text = getUnit(turquoise / 100);
      textref23.current.text = getUnit(turquoise / 100);
      textref24.current.text = getUnit(red / 100);
    }

    if (numerofwalls == 2) {
      textref1.current.text = getUnit(orange / 100);
      textref2.current.text = getUnit(green / 100);
      textref3.current.text = getUnit(green / 100);
      textref4.current.text = getUnit(green / 100);
      textref5.current.text = getUnit(green / 100);
      textref6.current.text = getUnit(green / 100);

      textref7.current.text =
        length == 1 ? getUnit(orange / 100) : getUnit(green / 100);
      textref8.current.text =
        length == 2 ? getUnit(orange / 100) : getUnit(green / 100);
      textref9.current.text =
        length == 3 ? getUnit(orange / 100) : getUnit(green / 100);

      textref10.current.text =
        length == 3 || length == 4
          ? getUnit(orange / 100)
          : getUnit(green / 100);
      textref11.current.text =
        length == 5 ? getUnit(orange / 100) : getUnit(green / 100);
      textref12.current.text =
        length == 6 ? getUnit(orange / 100) : getUnit(green / 100);

      textref19.current.text =
        width == 2 ? getUnit(turquoise / 100) : getUnit(red / 100);
      textref20.current.text =
        width == 4 ? getUnit(turquoise / 100) : getUnit(red / 100);
      textref21.current.text =
        width == 6 ? getUnit(turquoise / 100) : getUnit(red / 100);

      if (numerofcabins == 1) {
        textref19.current.text = getUnit(turquoise / 100);
        textref1.current.text = getUnit(orange / 100);

        if (bigcabin == false) {
          textref9.current.text = getUnit(green / 100);
          textref8.current.text =
            length == 3 || length == 2
              ? getUnit(orange / 100)
              : getUnit(green / 100);
        }
      }
    }

    if (numerofwalls == 2 && numerofcabins == 0) {
      textref12.current.text = getUnit(orange / 100);
      textref22.current.text =
        length == 6 || length == 5 || length == 3
          ? getUnit(red / 100)
          : getUnit(turquoise / 100);

      textref23.current.text =
        length == 6 ? getUnit(turquoise / 100) : getUnit(red / 100);
      textref24.current.text = getUnit(red / 100);

      textref20.current.text =
        width == 4 || width == 6
          ? getUnit(turquoise / 100)
          : getUnit(red / 100);
      textref21.current.text =
        width == 6 ? getUnit(red / 100) : getUnit(turquoise / 100);
    }

    if (numerofwalls == 3 && numerofcabins == 0) {
      textref1.current.text =
        width == 1 ? getUnit(orange / 100) : getUnit(green / 100);
      textref2.current.text =
        width == 2 ? getUnit(orange / 100) : getUnit(green / 100);
      textref3.current.text =
        width == 3 ? getUnit(orange / 100) : getUnit(green / 100);
      textref4.current.text =
        width == 5 ? getUnit(orange / 100) : getUnit(green / 100);
      textref5.current.text =
        width == 4 ? getUnit(orange / 100) : getUnit(green / 100);
      textref6.current.text =
        width == 6 ? getUnit(orange / 100) : getUnit(green / 100);

      textref7.current.text = getUnit(orange / 100);
      textref8.current.text =
        length == 2 ? getUnit(orange / 100) : getUnit(green / 100);
      textref9.current.text =
        length == 3 ? getUnit(orange / 100) : getUnit(green / 100);
      textref10.current.text =
        length == 4 ? getUnit(orange / 100) : getUnit(green / 100);
      textref11.current.text =
        length == 5 ? getUnit(orange / 100) : getUnit(green / 100);
      textref12.current.text = getUnit(orange / 100);

      textref13.current.text =
        width == 1 ? getUnit(orange / 100) : getUnit(green / 100);
      textref14.current.text =
        width == 2 ? getUnit(orange / 100) : getUnit(green / 100);
      textref15.current.text =
        width == 3 ? getUnit(orange / 100) : getUnit(green / 100);
      textref16.current.text =
        width == 4 ? getUnit(orange / 100) : getUnit(green / 100);
      textref17.current.text =
        width == 5 ? getUnit(orange / 100) : getUnit(green / 100);

      textref18.current.text = getUnit(orange / 100);

      textref25.current.text =
        width == 2 ? getUnit(turquoise / 100) : getUnit(red / 100);

      textref26.current.text =
        width == 4 ? getUnit(turquoise / 100) : getUnit(red / 100);
      textref27.current.text =
        width == 6 ? getUnit(turquoise / 100) : getUnit(red / 100);
    }

    if (numerofwalls == 3 && numerofcabins == 1) {
      // textref30.current.text = length == 2 ? getUnit(green /100) : getUnit(orange / 100)
    }

    if (numerofwalls == 3 && width == 1 && length == 1) {
      textref1.current.text = getUnit(orange / 100);
      textref7.current.text = getUnit(orange / 100);
      textref13.current.text = getUnit(orange / 100);
    }

    if (length == 1) {
      textref7.current.text = getUnit(orange / 100);
    }

    if (numerofwalls == 3 && numerofcabins == 0) {
      if (splitwall) {
        textref12.current.text = getUnit(green / 100);
        textref1.current.text = getUnit(orange / 100);

        if (length == 6) {
          textref23.current.text = getUnit(red / 100);
          textref22.current.text = getUnit(turquoise / 100);
          textref24.current.text = getUnit(turquoise / 100);
        }

        if (width == 6) {
          textref20.current.text = getUnit(turquoise / 100);

          textref21.current.text = getUnit(red / 100);
          textref19.current.text = getUnit(red / 100);
        }

        if (width == 5) {
          textref20.current.text = getUnit(red / 100);
          textref19.current.text = getUnit(red / 100);
        }

        if (width == 4) {
          textref20.current.text = getUnit(turquoise / 100);
          textref19.current.text = getUnit(red / 100);
        }

        if (width == 3) {
          textref19.current.text = getUnit(red / 100);
        }

        if (width == 2) {
          textref19.current.text = getUnit(turquoise / 100);
        }
      }
    }

    if (numerofwalls == 3 && numerofcabins == 1 && splitwall == false) {
      textref1.current.text =
        width == 2 ? getUnit(orange / 100) : getUnit(green / 100);
      textref2.current.text =
        width == 3 ? getUnit(orange / 100) : getUnit(green / 100);
      textref3.current.text =
        width == 4 ? getUnit(orange / 100) : getUnit(green / 100);
      textref5.current.text =
        width == 5 ? getUnit(orange / 100) : getUnit(green / 100);
      textref4.current.text =
        width == 6 ? getUnit(orange / 100) : getUnit(green / 100);
      textref6.current.text = getUnit(green / 100);

      textref18.current.text = getUnit(green / 100);
      textref13.current.text =
        width == 2 ? getUnit(orange / 100) : getUnit(green / 100);
      textref14.current.text =
        width == 3 ? getUnit(orange / 100) : getUnit(green / 100);
      textref15.current.text =
        width == 4 ? getUnit(orange / 100) : getUnit(green / 100);
      textref16.current.text =
        width == 5 ? getUnit(orange / 100) : getUnit(green / 100);
      textref17.current.text =
        width == 6 ? getUnit(orange / 100) : getUnit(green / 100);
    }

    if (
      numerofwalls == 3 &&
      numerofcabins == 1 &&
      splitwall == false &&
      bigcabin == false
    ) {
      textref7.current.text =
        length == 2 ? getUnit(orange / 100) : getUnit(green / 100);
      textref8.current.text =
        length == 3 || length == 2
          ? getUnit(orange / 100)
          : getUnit(green / 100);
      textref9.current.text =
        length == 3 || length == 4
          ? getUnit(orange / 100)
          : getUnit(green / 100);
      textref10.current.text =
        length == 4 || length == 5
          ? getUnit(orange / 100)
          : getUnit(green / 100);
      textref11.current.text =
        length == 5 || length == 6
          ? getUnit(orange / 100)
          : getUnit(green / 100);
      textref12.current.text =
        length == 6 ? getUnit(orange / 100) : getUnit(green / 100);
      textref32.current.text = getUnit(green / 100);
    }

    if (
      numerofwalls == 3 &&
      numerofcabins == 1 &&
      splitwall == false &&
      bigcabin == true
    ) {
      textref7.current.text =
        length == 2 ? getUnit(orange / 100) : getUnit(green / 100);
      textref8.current.text =
        length == 3 || length == 2
          ? getUnit(orange / 100)
          : getUnit(green / 100);
      textref9.current.text =
        length == 3 || length == 4
          ? getUnit(orange / 100)
          : getUnit(green / 100);
      textref10.current.text =
        length == 4 || length == 5
          ? getUnit(orange / 100)
          : getUnit(green / 100);
      textref11.current.text =
        length == 5 || length == 6
          ? getUnit(orange / 100)
          : getUnit(green / 100);
      textref12.current.text =
        length == 6 ? getUnit(orange / 100) : getUnit(green / 100);
      textref32.current.text = getUnit(green / 100);
    }

    if (
      numerofwalls == 3 &&
      numerofcabins == 1 &&
      splitwall == true &&
      bigcabin == false
    ) {
      textref7.current.text =
        length < 3 ? getUnit(orange / 100) : getUnit(green / 100);
      textref20.current.text =
        width == 5 ? getUnit(turquoise / 100) : getUnit(red / 100);
      textref26.current.text =
        width == 5 ? getUnit(turquoise / 100) : getUnit(red / 100);

      textref1.current.text =
        width == 5 ? getUnit(green / 100) : getUnit(green / 100);
    }

    if (numerofwalls == 2 && numerofcabins == 1) {
      if (width == 3 || width == 4 || width == 5) {
        textref1.current.text = getUnit(orange / 100);
      }

      if (width == 5) {
        textref19.current.text = getUnit(red / 100);
        textref20.current.text = getUnit(turquoise / 100);
      }

      if (width == 6) {
        textref19.current.text = getUnit(red / 100);
      }

      if (length == 3) {
        textref9.current.text = getUnit(green / 100);
      }

      if (length == 4) {
        textref22.current.text = getUnit(red / 100);
        textref23.current.text = getUnit(turquoise / 100);

        if (bigcabin == false) {
          textref22.current.text = getUnit(turquoise / 100);
        }
      }

      if (length == 5) {
        textref22.current.text = getUnit(red / 100);
        textref23.current.text = getUnit(red / 100);
        textref12.current.text = getUnit(orange / 100);

        if (bigcabin == false) {
          textref22.current.text = getUnit(turquoise / 100);
        }
      }

      if (length == 6) {
        textref22.current.text = getUnit(red / 100);
        textref23.current.text = getUnit(turquoise / 100);
        textref24.current.text = getUnit(red / 100);

        if (bigcabin == false) {
          textref23.current.text = getUnit(red / 100);
          textref8.current.text = getUnit(orange / 100);
        }
      }
    }

    if (width > 2 && length < 3 && numerofcabins == 1 && numerofwalls == 3) {
      textref29.current.text = getUnit(orange / 100);
      textref32.current.text = getUnit(orange / 100);
    }

    if (
      numerofwalls == 2 &&
      numerofcabins == 1 &&
      splitwall == false &&
      bigcabin == false &&
      length == 6
    ) {
      textref8.current.text = getUnit(green / 100);
    }

    if (
      numerofwalls == 2 &&
      numerofcabins == 1 &&
      bigcabin == true &&
      splitwall == false
    ) {
      if (length < 4) {
        gsap.to(Cabin1.current.position, {
          x: 0.54 + 0.86 * (width - 2),
          y: 0,
          z: 0.4,
          duration: duration,

          ease: ease,
        });

        gsap.to(Cabin2.current.position, {
          x: -24,
          y: 0,
          z: 1.1985,
          duration: duration,

          ease: ease,
        });

        gsap.to(BigCabinwall.current.position, {
          x: -24,
          y: 0,
          z: 1.1985,
          duration: duration,

          ease: ease,
        });

        gsap.to(Cabinwall.current.position, {
          x: 0.93 + 0.86 * (width - 2),
          y: 0,
          z: 0.872,
          duration: duration,

          ease: ease,
        });
      }

      if (length == 3) {
        textref8.current.text = getUnit(orange / 100);
      }
    }

    if (
      numerofwalls == 2 &&
      numerofcabins == 1 &&
      bigcabin == true &&
      splitwall == true
    ) {
      if (width == 3) {
        textref1.current.text = getUnit(green / 100);
      }

      if (width == 4) {
        textref1.current.text = getUnit(green / 100);
      }

      if (width == 5) {
        textref1.current.text = getUnit(green / 100);
      }

      if (length < 4) {
        gsap.to(Cabin1.current.position, {
          x: 0.54 + 0.86 * (width - 2),
          y: 0,
          z: 0.4,
          duration: duration,

          ease: ease,
        });

        gsap.to(Cabin2.current.position, {
          x: -24,
          y: 0,
          z: 1.1985,
          duration: duration,

          ease: ease,
        });

        gsap.to(BigCabinwall.current.position, {
          x: -24,
          y: 0,
          z: 1.1985,
          duration: duration,

          ease: ease,
        });

        gsap.to(Cabinwall.current.position, {
          x: 0.93 + 0.86 * (width - 2),
          y: 0,
          z: 0.872,
          duration: duration,

          ease: ease,
        });
      }
    }

    if (
      numerofwalls == 2 &&
      numerofcabins == 1 &&
      bigcabin == false &&
      splitwall == true
    ) {
      if (length == 3) {
        textref22.current.text = getUnit(turquoise / 100);
      }

      if (width == 3) {
        textref1.current.text = getUnit(green / 100);
      }

      if (width == 4) {
        textref1.current.text = getUnit(green / 100);
      }

      if (width == 5) {
        textref1.current.text = getUnit(green / 100);
      }
    }

    if (numerofwalls == 3 && numerofcabins == 0) {
      if (length == 4) {
        textref22.current.text = getUnit(turquoise / 100);
        textref23.current.text = getUnit(turquoise / 100);
      }

      if (length == 5) {
        textref23.current.text = getUnit(turquoise / 100);
      }
    }

    if (
      numerofwalls == 3 &&
      numerofcabins == 1 &&
      bigcabin == true &&
      splitwall == false
    ) {
      if (length == 3) {
        gsap.to(Cabin1.current.position, {
          x: 0.54 + 0.86 * (width - 2),
          y: 0,
          z: 0.4,
          duration: duration,

          ease: ease,
        });

        gsap.to(Cabin2.current.position, {
          x: -24,
          y: 0,
          z: 1.1985,
          duration: duration,

          ease: ease,
        });

        gsap.to(BigCabinwall.current.position, {
          x: -24,
          y: 0,
          z: 1.1985,
          duration: duration,

          ease: ease,
        });

        gsap.to(Cabinwall.current.position, {
          x: 0.93 + 0.86 * (width - 2),
          y: 0,
          z: 0.872,
          duration: duration,

          ease: ease,
        });
      }
    }

    if (
      numerofwalls == 3 &&
      numerofcabins == 1 &&
      bigcabin == true &&
      splitwall == true
    ) {
      if (width == 2) {
        textref1.current.text = getUnit(orange / 100);
      }

      if (width == 4) {
        textref17.current.text = getUnit(green / 100);
      }

      if (length == 3) {
        textref22.current.text = getUnit(turquoise / 100);
        textref7.current.text = getUnit(orange / 100);
      }

      if (length == 4) {
        textref23.current.text = getUnit(turquoise / 100);
      }

      if (length == 5) {
        textref22.current.text = getUnit(red / 100);
        textref12.current.text = getUnit(orange / 100);
        textref25.current.text = getUnit(turquoise / 100);
      }

      if (length == 6) {
        textref24.current.text = getUnit(turquoise / 100);
        textref25.current.text = getUnit(turquoise / 100);
      }

      if (length == 3) {
        gsap.to(Cabin1.current.position, {
          x: 0.54 + 0.86 * (width - 2),
          y: 0,
          z: 0.465,
          duration: duration,

          ease: ease,
        });

        gsap.to(Cabin1.current.scale, {
          y: 0.00101,
          duration: duration,

          ease: ease,
        });

        gsap.to(Cabin2.current.position, {
          x: -24,
          y: 0,
          z: 1.1985,
          duration: duration,

          ease: ease,
        });

        gsap.to(BigCabinwall.current.position, {
          x: -24,
          y: 0,
          z: 1.1985,
          duration: duration,

          ease: ease,
        });

        gsap.to(Cabinwall.current.position, {
          x: 0.93 + 0.86 * (width - 2),
          y: 0,
          z: 1,
          duration: duration,

          ease: ease,
        });
      }

      if (length == 4) {
        gsap.to(Cabinwall.current.position, {
          x: 0.93 + 0.86 * (width - 2),
          y: 0,
          z: 1.86,
          duration: duration,

          ease: ease,
        });

        gsap.to(BigCabinwall.current.position, {
          x: 0.54 + 0.86 * (width - 2),
          y: 0,
          z: 0.915,
          duration: duration,

          ease: ease,
        });

        gsap.to(BigCabinwall.current.scale, {
          z: 0.935,

          duration: duration,

          ease: ease,
        });
      } else {
        gsap.to(BigCabinwall.current.scale, {
          z: 0.844,

          duration: duration,

          ease: ease,
        });
      }
    }

    if (
      numerofwalls == 3 &&
      numerofcabins == 1 &&
      bigcabin == false &&
      splitwall == true
    ) {
      gsap.to(Cabin1.current.position, {
        x: 0.54 + 0.86 * (width - 2),
        y: 0,
        z: 0.455,
        duration: duration,

        ease: ease,
      });

      if (width == 2) {
        textref1.current.text = getUnit(orange / 100);
        textref2.current.text = getUnit(green / 100);
      }

      if (width == 3) {
        textref13.current.text = getUnit(green / 100);

        textref19.current.text = getUnit(turquoise / 100);
        textref25.current.text = getUnit(turquoise / 100);
      }

      if (width == 4) {
        textref19.current.text = getUnit(turquoise / 100);
        textref25.current.text = getUnit(turquoise / 100);
      }

      if (length == 3) {
        textref9.current.text = getUnit(orange / 100);
        textref8.current.text = getUnit(orange / 100);

        gsap.to(Cabin1.current.position, {
          x: 0.54 + 0.86 * (width - 2),
          y: 0,
          z: 0.4,
          duration: duration,

          ease: ease,
        });

        gsap.to(Cabin2.current.position, {
          x: -24,
          y: 0,
          z: 1.1985,
          duration: duration,

          ease: ease,
        });

        gsap.to(BigCabinwall.current.position, {
          x: -24,
          y: 0,
          z: 1.1985,
          duration: duration,

          ease: ease,
        });

        gsap.to(Cabinwall.current.position, {
          x: 0.93 + 0.86 * (width - 2),
          y: 0,
          z: 0.872,
          duration: duration,

          ease: ease,
        });
      }

      if (length == 4) {
        textref8.current.text = getUnit(green / 100);
        textref7.current.text = getUnit(orange / 100);
      }

      if (length == 5) {
        textref22.current.text = getUnit(turquoise / 100);
      }
    }

    if (numerofwalls == 3 && numerofcabins == 1 && splitwall == true) {
      if (length == 2) {
        textref8.current.text = getUnit(orange / 100);
        textref7.current.text = getUnit(orange / 100);
      }

      if (width == 3) {
        textref19.current.text = getUnit(turquoise / 100);
        textref25.current.text = getUnit(turquoise / 100);
      }

      if (width == 4) {
        textref1.current.text = getUnit(green / 100);
        textref18.current.text = getUnit(green / 100);
      }

      if (width == 5) {
        textref19.current.text = getUnit(red / 100);
        textref25.current.text = getUnit(red / 100);
      }

      if (width == 6) {
        textref1.current.text = getUnit(green / 100);
        textref20.current.text = getUnit(turquoise / 100);
        textref26.current.text = getUnit(turquoise / 100);
      }
    }

    if (numerofwalls == 1) {
      setnumerofcabins(0);

      gsap.to(ref8.current.position, {
        x: 27,
        duration: 1.5,
        ease: ease,
      });

      gsap.to(ref9.current.position, {
        x: 27,
        duration: 1.5,
        ease: ease,
      });
    }

    if (numerofwalls == 2 && numerofcabins == 1) {
      if (width < 2) {
        setwidth(2);
      }

      if (length < 2) {
        setlength(2);
      }
    }

    if (numerofwalls == 3) {
      if (numerofcabins == 1) {
        if (width < 2) {
          setwidth(2);
        }
      }

      if (numerofcabins == 0) {
        if (length < 2) {
          setlength(2);
        }
      }
    }

    if (numerofwalls == 3 && numerofcabins == 1) {
      if (width < 2) {
        setwidth(2);
      }

      if (length < 2) {
        setlength(2);
      }

      if (width == 2 && length == 2) {
        setTimeout(() => {
          setwidth(2);
          setlength(3);
        }, 500);
      }
    }

    if (numerofwalls == 1) {
      if (width == 1 && length > 2) {
        //  setnumberofcounters(1)
      }
    }


    if (
      numerofwalls == 3 &&
      numerofcabins == 1 &&
      bigcabin == true &&
      length < 4
    ) {
      gsap.to(BigCabinwall.current.position, {
        z: 27,
        duration: 1.5,
        ease: ease,
      });
    }

    if (numberofcounters == 0) {
      gsap.to(counter1.current.position, {
        x: -24,
        y: 0,
        z: 0,
        duration: duration,

        ease: ease,
      });

      gsap.to(counter1.current.rotation, {
        x: 0,
        y: 0,
        z: 0,
        duration: duration,

        ease: ease,
      });
      setcounter1visible(false);
    }


    if(numerofwalls == 2 && numerofcabins == 1 && width == 3 && length == 3 && numberofcounters == 2){
         setnumberofcounters(1)
    }

    if(numerofwalls == 2 && numerofcabins == 1 && width == 2 && length == 2 && numberofcounters == 2){
      setnumberofcounters(1)
 }

 if(numerofwalls == 2 && numerofcabins == 1 && width == 3 && length == 2 && numberofcounters == 2){
  setnumberofcounters(1)

  gsap.to(counter2.current.position, {
    x: -24,
 
    duration: duration,

    ease: ease,
  });

  gsap.to(counter2.current.rotation, {
    x: 0,
    y: 0,
    z: 0,
    duration: duration,

    ease: ease,
  });

}
//  if(numerofwalls == 2 && numerofcabins ==1 && width > 3 && length == 3 && numberofcounters == 2){
//   setnumberofcounters(1)
// }

// if(numerofwalls == 2 && numerofcabins ==1 && width > 1 && length == 4 && numberofcounters == 2){
//   setnumberofcounters(1)
// }

 if(numerofwalls == 3 && numerofcabins == 1 && width > 1 && width < 7 && length == 3 && numberofcounters == 2){
  setnumberofcounters(1)
}


if(numerofwalls == 3 && numerofcabins == 0 && width > 1 && width < 7 && length == 3 && numberofcounters == 2){
  setnumberofcounters(1)
}

// if(numerofwalls == 3 && numerofcabins == 1 && width < 3 && length >2 && numberofcounters == 2){
//   setnumberofcounters(1)
// }




  }, [
    width,
    length,
    height,
    numerofwalls,
    numberofcounters,
    numerofcabins,
    splitwall,
    bigcabin,
    setbigcabin,
  ]);

  useFrame(() => {
    textref1.current.position.set(
      ref.current.position.x,
      ref.current.position.y + height * 0.62 + 0.95,
      ref.current.position.z
    );
    textref2.current.position.set(
      ref2.current.position.x,
      ref2.current.position.y + height * 0.62 + 0.95,
      ref2.current.position.z
    );
    textref3.current.position.set(
      ref3.current.position.x,
      ref3.current.position.y + height * 0.62 + 0.95,
      ref3.current.position.z
    );
    textref4.current.position.set(
      ref6.current.position.x,
      ref6.current.position.y + height * 0.62 + 0.95,
      ref6.current.position.z
    );
    textref5.current.position.set(
      ref5.current.position.x,
      ref5.current.position.y + height * 0.62 + 0.95,
      ref5.current.position.z
    );
    textref6.current.position.set(
      ref7.current.position.x,
      ref7.current.position.y + height * 0.62 + 0.95,
      ref7.current.position.z
    );
    textref7.current.position.set(
      ref8.current.position.x,
      ref8.current.position.y + height * 0.62 + 0.95,
      ref8.current.position.z
    );
    textref8.current.position.set(
      ref9.current.position.x,
      ref9.current.position.y + height * 0.62 + 0.95,
      ref9.current.position.z
    );
    textref9.current.position.set(
      ref10.current.position.x,
      ref10.current.position.y + height * 0.62 + 0.95,
      ref10.current.position.z
    );
    textref10.current.position.set(
      ref11.current.position.x,
      ref11.current.position.y + height * 0.62 + 0.95,
      ref11.current.position.z
    );
    textref11.current.position.set(
      ref12.current.position.x,
      ref12.current.position.y + height * 0.62 + 0.95,
      ref12.current.position.z
    );
    textref11.current.position.set(
      ref12.current.position.x,
      ref12.current.position.y + height * 0.62 + 0.95,
      ref12.current.position.z
    );
    textref12.current.position.set(
      ref13.current.position.x,
      ref13.current.position.y + height * 0.62 + 0.95,
      ref13.current.position.z
    );
    textref13.current.position.set(
      ref14.current.position.x,
      ref14.current.position.y + height * 0.62 + 0.95,
      ref14.current.position.z
    );
    textref14.current.position.set(
      ref15.current.position.x,
      ref15.current.position.y + height * 0.62 + 0.95,
      ref15.current.position.z
    );
    textref15.current.position.set(
      ref16.current.position.x,
      ref16.current.position.y + height * 0.62 + 0.95,
      ref16.current.position.z
    );
    textref16.current.position.set(
      ref17.current.position.x,
      ref17.current.position.y + height * 0.62 + 0.95,
      ref17.current.position.z
    );
    textref17.current.position.set(
      ref18.current.position.x,
      ref18.current.position.y + height * 0.62 + 0.95,
      ref18.current.position.z
    );
    textref18.current.position.set(
      ref19.current.position.x,
      ref19.current.position.y + height * 0.62 + 0.95,
      ref19.current.position.z
    );
    textref19.current.position.set(
      bigwallleft1.current.position.x,
      bigwallleft1.current.position.y + height * 0.62 + 0.95,
      bigwallleft1.current.position.z
    );
    textref20.current.position.set(
      bigwallleft2.current.position.x,
      bigwallleft2.current.position.y + height * 0.62 + 0.95,
      bigwallleft2.current.position.z
    );
    textref21.current.position.set(
      bigwallleft3.current.position.x,
      bigwallleft3.current.position.y + height * 0.62 + 0.95,
      bigwallleft3.current.position.z
    );
    textref22.current.position.set(
      bigwallfront1.current.position.x,
      bigwallfront1.current.position.y + height * 0.62 + 0.95,
      bigwallfront1.current.position.z
    );
    textref23.current.position.set(
      bigwallfront2.current.position.x,
      bigwallfront2.current.position.y + height * 0.62 + 0.95,
      bigwallfront2.current.position.z
    );
    textref24.current.position.set(
      bigwallfront3.current.position.x,
      bigwallfront3.current.position.y + height * 0.62 + 0.95,
      bigwallfront3.current.position.z
    );
    textref25.current.position.set(
      bigwallright1.current.position.x,
      bigwallright1.current.position.y + height * 0.62 + 0.95,
      bigwallright1.current.position.z
    );
    textref26.current.position.set(
      bigwallright2.current.position.x,
      bigwallright2.current.position.y + height * 0.62 + 0.95,
      bigwallright2.current.position.z
    );
    textref27.current.position.set(
      bigwallright3.current.position.x,
      bigwallright3.current.position.y + height * 0.62 + 0.95,
      bigwallright3.current.position.z
    );
    textref29.current.position.set(
      Cabin1.current.position.x,
      Cabin1.current.position.y + height * 0.62 + 0.95,
      Cabin1.current.position.z
    );
    textref30.current.position.set(
      BigCabinwall.current.position.x,
      BigCabinwall.current.position.y + height * 0.62 + 0.95,
      BigCabinwall.current.position.z
    );
    textref31.current.position.set(
      Cabinwall.current.position.x,
      Cabinwall.current.position.y + height * 0.62 + 0.95,
      Cabinwall.current.position.z
    );
    textref32.current.position.set(
      Cabin2.current.position.x,
      Cabin2.current.position.y + height * 0.62 + 0.95,
      Cabin2.current.position.z
    );
  });

  const getWallSize = sizeInMm => {
    // if(unitS)
  };

  return (
    <group ref={groupref} position={[0, 0, 0]} {...props} dispose={null}>
      {/* <Text visible={showWallsLabels} rotation={[0,0,Math.PI * 0.5]} position={[-0.6, (height * 0.5) -0.1, 0]} fontSize={0.28}>
         {height}000 mm
         <meshBasicMaterial  color={'black'}/>
        </Text> */}

      {/* <Text visible={showWallsLabels} rotation={[0,-Math.PI * 0.5,0]} position={[  (width * 0.68),1.35 + (height * 0.5), (length * 0.5) - 0.2]} fontSize={0.28}>
         {length}000 mm
         <meshBasicMaterial color={'black'}/>
        </Text> */}
      {/* <primitive receiveShadow castShadow object={nodes.Profil}/> */}

      <primitive
        position={[24, 0, 0]}
        receiveShadow
        castShadow
        ref={ref}
        object={nodes.lightbox1}
      />

      <Text
        visible={showWallsLabels}
        ref={textref1}
        fontSize={0.135}
      >
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text visible={showWallsLabels} ref={textref2} fontSize={0.135}>
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text visible={showWallsLabels} ref={textref3} fontSize={0.135}>
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text visible={showWallsLabels} ref={textref4} fontSize={0.135}>
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text visible={showWallsLabels} ref={textref5} fontSize={0.135}>
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text visible={showWallsLabels} ref={textref6} fontSize={0.135}>
        {getUnit(850)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref7}
        rotation={[0, -Math.PI * 0.5, 0]}
        fontSize={0.135}
      >
        {getUnit(850)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref8}
        rotation={[0, -Math.PI * 0.5, 0]}
        fontSize={0.135}
      >
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref9}
        rotation={[0, -Math.PI * 0.5, 0]}
        fontSize={0.135}
      >
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref10}
        rotation={[0, -Math.PI * 0.5, 0]}
        fontSize={0.135}
      >
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref11}
        rotation={[0, -Math.PI * 0.5, 0]}
        fontSize={0.135}
      >
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref12}
        rotation={[0, -Math.PI * 0.5, 0]}
        fontSize={0.135}
      >
        {getUnit(850)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref13}
        rotation={[0, -Math.PI, 0]}
        fontSize={0.135}
      >
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref14}
        rotation={[0, -Math.PI, 0]}
        fontSize={0.135}
      >
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref15}
        rotation={[0, -Math.PI, 0]}
        fontSize={0.135}
      >
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref16}
        rotation={[0, -Math.PI, 0]}
        fontSize={0.135}
      >
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref17}
        rotation={[0, -Math.PI, 0]}
        fontSize={0.135}
      >
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref18}
        rotation={[0, -Math.PI, 0]}
        fontSize={0.135}
      >
        {getUnit(850)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref19}
        rotation={[0, 0, 0]}
        fontSize={0.135}
      >
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref20}
        rotation={[0, 0, 0]}
        fontSize={0.135}
      >
        {getUnit(1850)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref21}
        rotation={[0, 0, 0]}
        fontSize={0.135}
      >
        {getUnit(1850)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref22}
        rotation={[0, -Math.PI * 0.5, 0]}
        fontSize={0.135}
      >
        {getUnit(1850)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref23}
        rotation={[0, -Math.PI * 0.5, 0]}
        fontSize={0.135}
      >
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref24}
        rotation={[0, -Math.PI * 0.5, 0]}
        fontSize={0.135}
      >
        {getUnit(1850)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref25}
        rotation={[0, Math.PI, 0]}
        fontSize={0.135}
      >
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref26}
        rotation={[0, Math.PI, 0]}
        fontSize={0.135}
      >
        {getUnit(1000)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref27}
        rotation={[0, Math.PI, 0]}
        fontSize={0.135}
      >
        {getUnit(1850)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref28}
        position={[-0.56, 1.15, 0]}
        rotation={[0, 0, Math.PI * 0.5]}
        fontSize={0.15}
      >
        {getUnit(height)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref28}
        position={[-0.56, 0, 0.55]}
        rotation={[-Math.PI * 0.5, 0, -Math.PI * 0.5]}
        fontSize={0.15}
      >
        {getUnit(length)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref29}
        position={[-0.56, 0, 0.55]}
        rotation={[0, -Math.PI * 0.5, 0]}
        fontSize={0.115}
      >
        {getUnit(orange / 100)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref30}
        position={[-0.56, 0, 0.55]}
        rotation={[0, -Math.PI * 0.5, 0]}
        fontSize={0.115}
      >
        {getUnit(turquoise / 100)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref31}
        position={[-0.56, 0, 0.55]}
        rotation={[0, 0, 0]}
        fontSize={0.115}
      >
        {getUnit(orange / 100)}
        <meshBasicMaterial color={'black'} />
      </Text>

      <Text
        visible={showWallsLabels}
        ref={textref32}
        position={[-0.56, 0, 0.55]}
        rotation={[0, -Math.PI * 0.5, 0]}
        fontSize={0.115}
      >
        {getUnit(green / 100)}
        <meshBasicMaterial color={'black'} />
      </Text>

      {/* <Text visible={showWallsLabels} ref={textref32} position={[-0.56,0,0.55]} rotation={[0,-Math.PI * 0.25,0]} fontSize={0.125}>
        150 mm
         <meshBasicMaterial  color={'black'}/>
        </Text>

        <Text visible={showWallsLabels} ref={textref33}  fontSize={0.125} rotation={[0,-Math.PI * 0.7,0]}>
        150 mm
         <meshBasicMaterial  color={'black'}/>
        </Text> */}

      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref2}
        object={nodes.lightbox2}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref3}
        object={nodes.lightbox3}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref5}
        object={nodes.lightbox4}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref6}
        object={nodes.lightbox5}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref7}
        object={nodes.lightbox6}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref8}
        object={nodes.lightbox8}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref9}
        object={nodes.lightbox9}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref10}
        object={nodes.lightbox10}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref11}
        object={nodes.lightbox11}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref12}
        object={nodes.lightbox12}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref13}
        object={nodes.lightbox13}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref14}
        object={nodes.lightbox14}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref15}
        object={nodes.lightbox15}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref16}
        object={nodes.lightbox16}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref17}
        object={nodes.lightbox17}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref18}
        object={nodes.lightbox18}
      />
      <primitive
        position={[24, 0, -0.004]}
        receiveShadow
        castShadow
        ref={ref19}
        object={nodes.lightbox19}
      />
      <primitive
        position={[24, 0, 0.461]}
        receiveShadow
        castShadow
        ref={ref4}
        object={nodes.lightbox7}
      />

      {/* Big walls */}

      <primitive
        scale={[1, 1, 0.922]}
        position={[24, 0, 0.461]}
        receiveShadow
        castShadow
        ref={bigwallleft1}
        object={nodes.bigwallleft1}
      />
      <primitive
        scale={[1, 1, 0.922]}
        position={[24, 0, 0.461]}
        receiveShadow
        castShadow
        ref={bigwallleft2}
        object={nodes.bigwallleft2}
      />
      <primitive
        scale={[1, 1, 0.922]}
        position={[24, 0, 0.461]}
        receiveShadow
        castShadow
        ref={bigwallleft3}
        object={nodes.bigwallleft3}
      />

      <primitive
        scale={[1, 1, 0.922]}
        position={[24, 0, 0.461]}
        receiveShadow
        castShadow
        ref={bigwallright1}
        object={nodes.bigwallright1}
      />
      <primitive
        scale={[1, 1, 0.922]}
        position={[24, 0, 0.461]}
        receiveShadow
        castShadow
        ref={bigwallright2}
        object={nodes.bigwallright2}
      />
      <primitive
        scale={[1, 1, 0.922]}
        position={[24, 0, 0.461]}
        receiveShadow
        castShadow
        ref={bigwallright3}
        object={nodes.bigwallright3}
      />

      <primitive
        scale={[1, 1, 0.922]}
        position={[24, 0, 0.461]}
        receiveShadow
        castShadow
        ref={bigwallfront1}
        object={nodes.bigwallfront1}
      />
      <primitive
        scale={[1, 1, 0.922]}
        position={[24, 0, 0.461]}
        receiveShadow
        castShadow
        ref={bigwallfront2}
        object={nodes.bigwallfront2}
      />
      <primitive
        scale={[1, 1, 0.922]}
        position={[24, 0, 0.461]}
        receiveShadow
        castShadow
        ref={bigwallfront3}
        object={nodes.bigwallfront3}
      />

      <primitive
        position={[-24, 0, 0.461]}
        scale={[nodes.Cabin1.scale.x, 0.00092, nodes.Cabin1.scale.z]}
        receiveShadow
        castShadow
        ref={Cabin1}
        object={nodes.Cabin1}
      />
      <primitive
        position={[-24, 0, 1.325]}
        scale={[nodes.Cabin2.scale.x, 0.00092, nodes.Cabin2.scale.z]}
        receiveShadow
        castShadow
        ref={Cabin2}
        object={nodes.Cabin2}
      />
      <primitive
        rotation={[-Math.PI * 0.5, 0, Math.PI * 0.5]}
        scale={[nodes.Cabinwall.scale.x, 0.00082, nodes.Cabinwall.scale.z]}
        position={[-24, 0, 0.461]}
        receiveShadow
        castShadow
        ref={Cabinwall}
        object={nodes.Cabinwall}
      />
      <primitive
        rotation={[-Math.PI * 1, Math.PI, Math.PI * 0.5]}
        scale={[nodes.BigCabinwall.scale.x, nodes.BigCabinwall.scale.y, 0.844]}
        position={[-24, 0, 0.461]}
        receiveShadow
        castShadow
        ref={BigCabinwall}
        object={nodes.BigCabinwall}
      />

      <primitive
        position={[-24, 0, 0.461]}
        receiveShadow
        castShadow
        ref={counter1}
        object={nodes.counter1}
      />
      <primitive
        position={[-24, 0, 0.461]}
        receiveShadow
        castShadow
        ref={counter2}
        object={nodes.counter2}
      />

      <primitive
        position={[-0.4, -0.0099, -0.075]}
        receiveShadow
        castShadow
        ref={groundref}
        object={nodes.Ground}
      />
    </group>
  );
}

useGLTF.preload('/door.glb');
